<template>
  <b-container fluid>
    <backlink />
    <h1>Groupes d'agences</h1>

    <AdminTable :config="config"></AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTable";
import config from "./config";

export default {
  name: "AgencyGroupList",
  components: {
    AdminTable,
  },
  data() {
    return {
      config: config,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/AgencyGroup/AgencyGroupList.vue